import { About1Props } from "../../props";
import styles from "./about-variant-03.module.scss";

export const AboutVariant03 = (props: About1Props) => (
  <section className={`${styles.container} container-${props.id}`}>
    <div
      className={`${styles.container__content} container__content-${props.id}`}
    >
      <div
        className={`${styles.content__wrapper} content__wrapper-${props.id}`}
      >
        {typeof props.heading != "undefined" &&
          typeof props.heading.value != "undefined" && (
            <h2 className={`${styles.title} title-${props.id}`}>
              {props.heading.value}
            </h2>
          )}
        {typeof props.description != "undefined" &&
          typeof props.description.value != "undefined" && (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  (props.description.value as string) ??
                  (props.description as unknown as string),
              }}
            />
          )}
      </div>
    </div>
  </section>
);
